module.exports = __webpack_public_path__ + "static/media/vortex.212d118d.png";